import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import serializer from './serializer';
import DataFilter from './DataFilter';
import DEFAULT_FILTER from './defaultFilter';

var nextSearch = function nextSearch(baseValue, _ref) {
  var filter = _ref.filter,
      value = _ref.value;
  return _objectSpread({}, baseValue, {
    searchIn: filter,
    searchValue: value
  });
};

var nextFilter = function nextFilter(baseValue, e, _ref2) {
  var label = _ref2.label,
      value = _ref2.value;

  if (!value) {
    return _objectSpread({}, baseValue, {
      label: null,
      filterBy: null,
      filterValue: null
    });
  }

  var filterBys = Object.keys(value);

  if (filterBys.length === 0) {
    return _objectSpread({}, baseValue, {
      label: null,
      filterBy: null,
      filterValue: null
    });
  }

  return _objectSpread({}, baseValue, {
    label: label,
    filterBy: filterBys[0],
    filterValue: value[filterBys[0]]
  });
};

var createOnChange = function createOnChange(value, fn) {
  return {
    search: function search() {
      for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }

      var val = nextSearch.apply(void 0, [value].concat(rest));
      var q = serializer.serialize(val);
      if (value.searchValue !== val.searchValue) return fn(q);
    },
    filter: function filter() {
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }

      var val = nextFilter.apply(void 0, [value].concat(rest));
      var q = serializer.serialize(val);
      return fn(q);
    }
  };
};

var LocationDataFilter = function LocationDataFilter(_ref3) {
  var location = _ref3.location,
      history = _ref3.history,
      options = _ref3.options,
      children = _ref3.children,
      searchIn = _ref3.searchIn,
      label = _ref3.label,
      rest = _objectWithoutProperties(_ref3, ["location", "history", "options", "children", "searchIn", "label"]);

  var defaultLabel = options && options.find(function (o) {
    return o.value === null;
  });
  if (defaultLabel) defaultLabel = defaultLabel.label;
  if (!defaultLabel) defaultLabel = label;
  var value = serializer.createFromLocation(location, _objectSpread({}, DEFAULT_FILTER, {
    searchIn: searchIn,
    label: defaultLabel
  }));
  var onChange = createOnChange(value, function (q) {
    var newPath = serializer.getNewLocation(location, q);
    history.push(newPath);
  });
  return React.createElement(DataFilter, Object.assign({
    value: value,
    onChange: onChange,
    options: options
  }, rest), children);
};

LocationDataFilter.defaultProps = {
  location: null,
  history: null,
  searchIn: 'name',
  label: 'All'
};
export default LocationDataFilter;